import React from 'react'
import Homecomponent from '../components/Home/Home'

const Home = () => {
  return (
    <>
      <Homecomponent />
    </>
  )
}

export default Home
